import createStaticResourceAPI from "@/helpers/rtk_static_resource_factory";

const baseURL = process.env.REACT_APP_GLOBO_API + "/transactions/patientEnrollments";
const type = "PatientEnrollments";

export const patientEnrollmentsAPI = createStaticResourceAPI({
  baseURL: baseURL,
  resource: "PatientEnrollments",
  tagTypes: ["PatientEnrollments"],
  idKey: "patientEnrollmentId",
  lookupMap: ({ patientEnrollmentId, referenceNo }) => ({
    value: patientEnrollmentId,
    label: referenceNo,
  }),
  customQuery: (query, { idKey, resource, baseURL }) => ({
    getListPatientEnrollmentsForViewers: query(`${baseURL}/listForViewer`, {
      serializeQueryArgs: ({ endpointName }) => endpointName,
      providesTags: (result) => {
        if (!result?.success || !Array.isArray(result.returnData)) {
          return [{ type: resource, id: "LIST" }];
        }

        return [
          ...result.returnData.map((item) => ({
            type: resource,
            id: item[idKey],
          })),
          { type: resource, id: "LIST" },
        ];
      },
    }),
      getFilesPatientEnrollments: query(`${baseURL}/files/list`, {
      serializeQueryArgs: ({ endpointName }) => endpointName,
      providesTags: (result) =>
        result?.success
          ? [...(result?.items || result?.returnData)?.map((item) => ({ type: type, id: item[idKey] })), { type: type, id: type }]
          : [{ type: type, id: type }],
    }),
  }),
  customMutations: (mutation, mutationOptions) => ({
    submitPatientEnrollments: mutation(`${baseURL}/submit`, mutationOptions("save")),
    returnPatientEnrollments: mutation(`${baseURL}/return`, mutationOptions("save")),
    approvePatientEnrollments: mutation(`${baseURL}/approve`, mutationOptions("save")),
    rejectPatientEnrollments: mutation(`${baseURL}/reject`, mutationOptions("save")),
    cancelPatientEnrollments: mutation(`${baseURL}/cancel`, mutationOptions("save")),
    filesUploadPatientEnrollments: mutation(`${baseURL}/files/upload`),
    filesDeletePatientEnrollments: mutation(`${baseURL}/files/delete`),
  }),
});

export const {
  useGetPatientEnrollmentsQuery,
  useGetListPatientEnrollmentsForViewersQuery,
  useExportPatientEnrollmentsMutation,
  useFindPatientEnrollmentsQuery,
  useLookUpPatientEnrollmentsMutation,
  useSavePatientEnrollmentsMutation,
  useSubmitPatientEnrollmentsMutation,
  useReturnPatientEnrollmentsMutation,
  useApprovePatientEnrollmentsMutation,
  useRejectPatientEnrollmentsMutation,
  useCancelPatientEnrollmentsMutation,
  useDeletePatientEnrollmentsMutation,
  useFilesUploadPatientEnrollmentsMutation,
  useFilesDeletePatientEnrollmentsMutation,
  useGetFilesPatientEnrollmentsQuery
} = patientEnrollmentsAPI;
